import React, {FC, ReactNode} from 'react';
import {useKeyboard, View} from '@lookiero/aurora';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

interface FooterProps {
  readonly children: ReactNode;
}

const Footer: FC<FooterProps> = ({children}) => {
  const {bottom: bottomSafeAreaInset} = useSafeAreaInsets();
  const {willShow} = useKeyboard();

  if (willShow) return null;

  return <View style={{paddingBottom: bottomSafeAreaInset}}>{children}</View>;
};

export {Footer};
